import { render, staticRenderFns } from "./PublicGuide.vue?vue&type=template&id=5a7a2d04&scoped=true&"
import script from "./PublicGuide.vue?vue&type=script&lang=js&"
export * from "./PublicGuide.vue?vue&type=script&lang=js&"
import style0 from "./PublicGuide.vue?vue&type=style&index=0&id=5a7a2d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7a2d04",
  null
  
)

export default component.exports